const uz = {
    meta: {
        title: "Marketpleys va sayt qoldig'ini sinxronlash: hisob va narx",
        description:
            "Bitta ombor, uchta kanal. Ortiqcha sotish qancha turadi, nima sinxronlanadi, integratsiya qanchadan foydali bo'ladi va necha oyda o'zini oqlaydi — ochiq hisob.",
        keywords: [
            "marketpleys va sayt qoldiqni sinxronlash",
            "ombor qoldig'ini avtomatlashtirish",
            "bir nechta savdo kanali boshqaruvi",
            "Uzum bilan integratsiya API",
            "buyurtmalarni bitta tizimda yig'ish",
        ],
    },
    h1: "Bitta ombor, uchta kanal: qoldiqni qanday sinxronlash kerak",
    lead:
        "Sotuvchi endi bitta kanalda turmaydi: marketpleys, o'z sayti va oflayn do'kon bir vaqtda ishlaydi. Ombor esa bitta. Qoldiq sinxronlanmasa, bitta tovar ikki joyda sotiladi va buyurtma bekor qilinadi.",
    category: "Elektron tijorat",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Bu maqola texnik emas, hisob-kitob haqida. Integratsiya kerakmi yoki Excel hali yetadimi — buni his bilan emas, ikki raqam bilan aniqlash mumkin: nechta SKU va nechta kanal. Quyida shu hisobni ochiq ko'rsatamiz.",
        },

        { type: "h2", text: "Nega bitta ombor endi uchta kanalda turibdi?" },
        {
            type: "p",
            text:
                "Elektron savdo platformalari soni bir yil ichida 36 tadan 115 taga chiqdi. Sotuvchi uchun bu shuni anglatadi: bitta maydonchada qolish endi tanlov emas, cheklov. Amalda ko'p biznes kamida ikkita marketpleys, o'z sayti va oflayn nuqtada bir vaqtda sotadi.",
        },
        {
            type: "p",
            text:
                "Ikkinchi sabab — komissiya strukturasi. 2026-yil 1-maydan Uzum Market komissiyasi tovar kategoriyasiga bog'landi va kategoriyaga qarab 3% dan 35% gacha. Shu sanadan logistika yig'imi ham joriy etildi — 2 000 so'mdan 20 000 so'mgacha. Endi qaysi kategoriyani qaysi kanalda sotish alohida qaror bo'lib qoldi.",
        },
        {
            type: "p",
            text:
                "Uchinchi sabab — markirovka. 2026-yil 1-iyuldan markirovka qilingan tovar sotilganda markirovka kodi onlayn-KKM chekida majburiy aks etadi. Ya'ni qoldiqni endi «10 dona bor» darajasida emas, aniq kod darajasida yuritish kerak bo'ladi. Excelda buni uchta kanal bo'ylab yuritib bo'lmaydi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Qo'lda yuritish qayerda buziladi?" },
        {
            type: "p",
            text:
                "Qo'lda yuritish bir kanalda ishlaydi, ikkitasida qiynaladi, uchtasida buziladi. Buzilish nuqtasi har doim bir xil — vaqt farqi.",
        },
        {
            type: "p",
            text:
                "Menejer qoldiqni ertalab kiritadi. Kun davomida marketpleysda beshta, saytda ikkita, do'konda uchta sotiladi. Kechqurun raqamlar yangilanadi. Oradagi sakkiz soatda tizim mavjud bo'lmagan tovarni sotishda davom etadi.",
        },
        {
            type: "list",
            items: [
                "Ortiqcha sotish (oversell): tovar yo'q, buyurtma qabul qilingan. Bekor qilishga to'g'ri keladi.",
                "Marketpleysdagi reyting tushadi, kartochka ko'rsatishlari kamayadi va bu aylanmaga uradi.",
                "Mijoz ishonchi yo'qoladi — bekor qilingan buyurtma odatda qaytib kelmaydi.",
                "Narx nomuvofiqligi: aksiya bitta kanalda o'zgartiriladi, boshqasida eski narx qoladi.",
                "Menejer vaqti: amaliyotimizda qoldiqni qo'lda kiritish kuniga bir-ikki soatni oladi.",
            ],
        },
        {
            type: "p",
            text:
                "Muhim nuqta: bu muammo assortiment kattalashganda emas, kanal qo'shilganda keskinlashadi. Ikkinchi kanal xatolarni ikki barobar emas, ancha ko'proq oshiradi, chunki tekshirish kerak bo'lgan juftliklar soni ortadi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Ortiqcha sotish qanchaga tushadi?" },
        {
            type: "p",
            text:
                "Bu bandni aniq hisoblash mumkin. Formula oddiy: bekor qilingan buyurtmalar soni × o'rtacha chek × marja. Ustiga bilvosita yo'qotishlar qo'shiladi.",
        },
        {
            type: "p",
            text:
                "Misol: oyiga 600 buyurtma, o'rtacha chek 250 000 so'm, marja 25%. Agar buyurtmalarning 3% i qoldiq nomuvofiqligi sababli bekor qilinsa — bu 18 ta buyurtma, 4,5 mln so'm aylanma va 1,1 mln so'm sof foyda. Har oyda.",
        },
        {
            type: "p",
            text:
                "Buning ustiga menejer vaqti keladi: kuniga bir soat qo'lda kiritish oyiga 22 soat. Va eng qimmati — reyting. Marketpleysda bekor qilish ko'rsatkichi ko'tarilsa, kartochka pastga tushadi va uni qaytarish bir necha oy oladi.",
        },
        {
            type: "callout",
            text:
                "O'z raqamingizni qo'ying: oylik buyurtma soni × bekor qilish foizi × o'rtacha chek × marja. Chiqqan summa — integratsiyaga har oy ajrata oladigan byudjetingiz.",
        },

        { type: "h2", text: "Aslida nima sinxronlanadi?" },
        {
            type: "p",
            text:
                "«Sinxronizatsiya» so'zi ostida odatda faqat qoldiq tushuniladi. Aslida to'rtta oqim bor va ularning har biri alohida yo'nalishda harakatlanadi.",
        },
        {
            type: "table",
            head: ["Ma'lumot", "Yo'nalish", "Qanchalik tez kerak", "Nima bo'ladi sinxron bo'lmasa"],
            rows: [
                ["Qoldiq", "Ombordan kanallarga", "Deyarli real vaqtda", "Ortiqcha sotish va bekor qilish"],
                ["Narx va aksiya", "Ombordan kanallarga", "Kuniga bir necha marta", "Turli kanalda turli narx, nizo"],
                ["Buyurtma", "Kanallardan omborga", "Darhol", "Buyurtma o'tkazib yuboriladi"],
                ["Buyurtma statusi", "Ombordan kanallarga", "Bosqich o'zgarganda", "Mijoz qo'ng'iroq qiladi, operator bilmaydi"],
                ["Tovar kartochkasi", "Ombordan kanallarga", "O'zgarganda", "Eski tavsif va rasm, qaytarishlar ortadi"],
            ],
        },
        {
            type: "p",
            text:
                "Amaliy maslahat: hammasini birdan qilmang. Birinchi bosqichda faqat qoldiq va buyurtmani ulang — bu yo'qotishlarning katta qismini yopadi. Narx va kartochka ikkinchi bosqichda qo'shiladi.",
        },

        { type: "h2", text: "Integratsiya qanday qurilaladi?" },
        {
            type: "p",
            text:
                "Arxitektura printsipi bitta: yagona haqiqat manbai. Qoldiq qayerda saqlanishini bir marta hal qilasiz va qolgan hamma joy shundan o'qiydi.",
        },
        {
            type: "ol",
            items: [
                "Markazda hisob tizimi turadi — 1C, ERP yoki ombor moduli. Qoldiq faqat shu yerda o'zgaradi.",
                "Har bir kanal uchun konnektor yoziladi: marketpleys API, sayt, kassa yoki POS tizimi.",
                "Qoldiq o'zgarganda markaz kanallarga yangilanish yuboradi; kanal buyurtma tushganda markazga xabar beradi.",
                "Rezerv mantig'i: sotilgan tovar darhol bloklanadi, buyurtma bekor bo'lsa qaytariladi.",
                "Nizolarni hal qilish qoidasi: ikki kanalda bir vaqtda sotilsa, qaysi biri ustun — buni oldindan belgilang.",
                "Jurnal va ogohlantirish: sinxronizatsiya to'xtasa, buni ertaga emas, o'sha zahoti bilish kerak.",
            ],
        },
        {
            type: "p",
            text:
                "Eng ko'p e'tibordan chetda qoladigan band — beshinchisi. Nizo qoidasi yozilmasa, tizim texnik jihatdan to'g'ri ishlaydi, lekin amalda tushunarsiz natijalar beradi.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Qachon integratsiya o'zini oqlaydi?" },
        {
            type: "p",
            text:
                "Bu yerda ikkita raqam hal qiladi: SKU soni va kanal soni. Ular ko'paygan sari qo'lda yuritish xarajati chiziqli emas, tezroq o'sadi.",
        },
        {
            type: "table",
            head: ["Vaziyat", "Tavsiya", "Sabab"],
            rows: [
                ["1 kanal, 50 tagacha SKU", "Qo'lda yuriting", "Xatolar kam, avtomatlashtirish qaytmaydi"],
                ["2 kanal, 200 tagacha SKU", "Yarim avtomatik: umumiy jadval va kunlik yuklash", "Xatolar bor, lekin boshqarsa bo'ladi"],
                ["2–3 kanal, 200 dan ortiq SKU", "To'liq integratsiya", "Qo'lda yuritish xatolari byudjetdan oshadi"],
                ["3 va undan ortiq kanal", "To'liq integratsiya, istisnosiz", "Qo'lda nazorat amalda imkonsiz"],
                ["Markirovka qilinadigan tovar", "To'liq integratsiya", "Kodni qo'lda yuritib bo'lmaydi"],
            ],
        },
        {
            type: "p",
            text:
                "Chegara taxminan shunday chiqadi: ikkita kanal va ikki yuzdan ortiq SKU. Shu nuqtadan keyin qo'lda yuritishning oylik zarari integratsiya amortizatsiyasidan oshib ketadi.",
        },

        { type: "h2", text: "Qancha turadi va necha oyda qaytadi?" },
        {
            type: "p",
            text:
                "Innobek'da ERP va hisob tizimlari 40 000 000 so'mdan boshlanadi, murakkab konfiguratsiyalar 75 000 000 so'mdan. Agar sizda hisob tizimi allaqachon bo'lsa, faqat konnektor yozish ancha kichikroq ish bo'ladi — u kanallar soniga va API imkoniyatlariga bog'liq.",
        },
        {
            type: "p",
            text:
                "Narxga kirmaydi: marketpleys tomonidagi tariflar, ombor uskunasi va shtrix-kod skanerlari, ma'lumotlarni boshlang'ich tozalash. Oxirgi band ko'pincha eng ko'p vaqt oladi: nomlar, o'lchov birliklari va artikullar kanallar bo'ylab har xil yozilgan bo'ladi.",
        },
        {
            type: "p",
            text:
                "Qaytim hisobi yuqoridagi formuladan chiqadi. Oyiga 1,1 mln so'm foyda yo'qotishi — bu yiliga 13,2 mln so'm; ustiga 22 soat menejer vaqti har oy. Mavjud tizimga konnektor qo'shish odatda bir yil ichida qaytadi, noldan ERP esa 18–24 oyda.",
        },
        {
            type: "p",
            text:
                "Muhim ogohlantirish: bu hisob faqat kanal va SKU soni yuqoridagi jadvaldagi chegaradan oshganida ishlaydi. Undan pastda integratsiya texnik jihatdan to'g'ri, iqtisodiy jihatdan esa erta bo'ladi.",
        },

        { type: "h2", text: "Hech narsa qilmaslik narxi nimadan iborat?" },
        {
            type: "p",
            text:
                "Qoldiqni qo'lda yuritish xarajati hisobotda alohida qator bo'lib ko'rinmaydi — u boshqa raqamlar ichida tarqalib ketadi.",
        },
        {
            type: "list",
            items: [
                "Bekor qilingan buyurtmalardagi yo'qotilgan marja — eng katta va eng ko'rinmas band.",
                "Marketpleys reytingining tushishi va undan keyingi ko'rsatishlar kamayishi.",
                "Menejer vaqti: kuniga bir-ikki soat, yiliga bir necha yuz soat.",
                "Ortiqcha zaxira: xato qilmaslik uchun ombor ataylab to'ldiriladi, pul tovarda qotib qoladi.",
                "Qaror sifati: qaysi kanal qaysi kategoriyada foydali ekanini aniq bilib bo'lmaydi.",
            ],
        },

        { type: "h2", text: "Qachon integratsiya kerak emas?" },
        {
            type: "p",
            text:
                "Integratsiya universal yechim emas. Quyidagi holatlarda biz byudjetni boshqa narsaga yo'naltirishni tavsiya qilamiz.",
        },
        {
            type: "list",
            items: [
                "Bitta kanal va ellik tagacha SKU. Bu yerda Excel va intizom yetarli.",
                "Tovar buyurtma asosida ishlab chiqariladi — ombor qoldig'i tushunchasi deyarli yo'q.",
                "Assortiment doimiy o'zgaradi va hech qachon takrorlanmaydi, masalan qo'lda ishlangan buyumlarda.",
                "Hisob tizimi hali yo'q va u yaqin oyda paydo bo'lmaydi. Avval hisobni yig'ing, keyin ulang.",
                "Kanallardan biri tajriba sifatida ochilgan va uch oydan keyin yopilishi mumkin.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "p",
            text:
                "Qolgan barcha holatlarda tartib quyidagicha: avval hisob tizimida qoldiqni tartibga soling, keyin eng katta kanalni ulang, so'ng qolganlarini. Hammasini bir vaqtda ulash urinishi loyihani cho'zadi va natijani kechiktiradi.",
        },
        {
            type: "p",
            text:
                "Natijani qanday o'lchashni ham oldindan kelishib oling. Uchta ko'rsatkich yetarli: qoldiq nomuvofiqligi sababli bekor qilingan buyurtmalar ulushi, menejerning qoldiq bilan ishlash vaqti va marketpleysdagi bekor qilish ko'rsatkichi. Ularni integratsiyadan oldin o'lchang. Aks holda uch oydan keyin loyiha nima berganini raqam bilan aytib bo'lmaydi.",
        },
    ],

    faq: [
        {
            q: "Nechta kanaldan boshlab sinxronizatsiya kerak bo'ladi?",
            a: "Amaliy chegara — ikkita kanal va ikki yuzdan ortiq SKU. Bitta kanal va ellik tagacha SKU bo'lsa, Excel va intizom yetarli. Uchta va undan ortiq kanalda esa qo'lda nazorat amalda imkonsiz bo'lib qoladi. Markirovka qilinadigan tovarlar bilan ishlasangiz, kanallar soni kam bo'lsa ham integratsiya kerak.",
        },
        {
            q: "Ortiqcha sotish qancha zarar keltiradi?",
            a: "Formula shunday: oylik buyurtma soni × bekor qilish foizi × o'rtacha chek × marja. Masalan, 600 buyurtma, 3% bekor qilish, 250 000 so'm chek va 25% marjada bu oyiga taxminan 1,1 mln so'm sof foyda. Ustiga marketpleysdagi reyting tushishi qo'shiladi — uni tiklash bir necha oy oladi.",
        },
        {
            q: "Nima aynan sinxronlanadi?",
            a: "To'rtta asosiy oqim bor: qoldiq (ombordan kanallarga, deyarli real vaqtda), narx va aksiyalar, buyurtmalar (kanallardan omborga, darhol) hamda buyurtma statusi. Beshinchisi — tovar kartochkasi, ya'ni tavsif va rasmlar. Birinchi bosqichda faqat qoldiq va buyurtmani ulang: bu yo'qotishlarning katta qismini yopadi va boshqa bloklarga qaraganda ancha tezroq ishga tushadi.",
        },
        {
            q: "Integratsiya qancha turadi?",
            a: "Innobek'da ERP va hisob tizimlari 40 000 000 so'mdan, murakkab konfiguratsiyalar 75 000 000 so'mdan. Agar hisob tizimingiz allaqachon bo'lsa, faqat konnektor yozish ancha kichikroq ish. Narxga kirmaydi: marketpleys tariflari, ombor uskunasi va ma'lumotlarni boshlang'ich tozalash — oxirgisi ko'pincha eng ko'p vaqt oladi.",
        },
        {
            q: "Markirovka qoldiq hisobiga qanday ta'sir qiladi?",
            a: "2026-yil 1-iyuldan markirovka qilingan tovar sotilganda markirovka kodi onlayn-KKM chekida majburiy aks etadi. Bu qoldiqni «shuncha dona» darajasida emas, aniq kod darajasida yuritishni talab qiladi. Bir necha kanalda bunday hisobni qo'lda olib borish mumkin emas, shuning uchun integratsiya majburiy bo'lib qoladi.",
        },
        {
            q: "Marketpleysdan voz kechsam, muammo hal bo'ladimi?",
            a: "Yo'q, bu odatda yomonroq yechim bo'ladi. Marketpleys sizga tayyor trafik va xaridor ishonchini beradi, ularni noldan qurish ancha qimmatga tushadi. To'g'ri yo'l — kanallarni saqlab qolgan holda qoldiqni bitta manbadan yuritish. Yuqori komissiyali kategoriyalarni saytga olib chiqish esa alohida qaror va u sinxronizatsiya ishlab turganidan keyin ancha osonlashadi.",
        },
    ],

    cta: {
        h: "Kanallaringizni bitta omborga bog'laymiz",
        p: "Nechta kanalda va nechta SKU bilan ishlayotganingizni ayting — integratsiya hajmini, muddatini va qaytim hisobini bepul tayyorlaymiz.",
        button: "Hisobni so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-omnichannel.webp",
            alt: "Bitta ombordan uchta savdo kanaliga ma'lumot oqimi",
            caption: "Bitta ombor, uchta kanal — qoldiq faqat bitta joyda o'zgarishi kerak",
            prompt:
                "Hub-and-spoke illustration: a central warehouse icon connected by animated-looking data lines to three channel icons — marketplace storefront, own website and a physical shop counter; isometric-lite flat vector, blue and teal, clean white background, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-integration-arch.webp",
            alt: "Qoldiq, narx, buyurtma va status almashinuvi arxitekturasi",
            caption: "Yagona haqiqat manbai: markazda hisob tizimi, chetlarda konnektorlar",
            prompt:
                "Integration architecture diagram: ERP/stock core in the middle, API connectors on the left to marketplace and on the right to web store and POS, with arrows labelled stock, price, order, status; clean technical line style, blue highlights, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-stock-mismatch.webp",
            alt: "Qo'lda yuritilgan nomuvofiq qoldiq va sinxronlangan yagona qoldiq",
            caption: "Chapda — uchta kanaldagi uchta raqam, o'ngda — bitta haqiqiy qoldiq",
            prompt:
                "Before-and-after comparison: left a spreadsheet with mismatched stock numbers highlighted in red across three columns; right a single dashboard row showing one synced stock figure with green status across three channel badges; minimal light UI, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/bobo-market-app.webp",
            alt: "Bobo Market ilovasi — katalog va buyurtma boshqaruvi",
            caption: "Bobo Market — ko'p kanalli savdo uchun katalog va buyurtma boshqaruvi",
        },
    ],

    relatedServices: ["erp-tizimlar", "internet-dokonlar", "veb-ilovalar"],
    relatedPosts: ["marketpleys-yoki-oz-internet-dokon", "onlayn-tolov-ulash-payme-click", "internetdokon"],
};

const ru = {
    meta: {
        title: "Синхронизация остатков маркетплейса и сайта: расчёт",
        description:
            "Один склад, три канала. Сколько стоит оверселл, что именно синхронизируется, с какого объёма интеграция выгодна и за сколько окупается — открытый расчёт.",
        keywords: [
            "синхронизация остатков маркетплейс и сайт",
            "автоматизация складских остатков",
            "омниканальные продажи Узбекистан",
            "интеграция с API маркетплейса",
            "система управления заказами OMS",
        ],
    },
    h1: "Один склад, три канала: как правильно синхронизировать остатки",
    lead:
        "Продавец больше не ограничивается одним каналом: маркетплейс, свой сайт и офлайн-точка работают одновременно. А склад один. Если остатки не синхронизированы, товар продаётся дважды и заказ приходится отменять.",
    category: "Электронная коммерция",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Эта статья не про технику, а про расчёт. Нужна ли интеграция или Excel ещё справляется — определяется не ощущением, а двумя числами: сколько у вас SKU и сколько каналов. Ниже мы показываем этот расчёт открыто.",
        },

        { type: "h2", text: "Почему один склад оказался в трёх каналах?" },
        {
            type: "p",
            text:
                "Число электронных торговых платформ за год выросло с 36 до 115. Для продавца это означает простую вещь: оставаться на одной площадке — уже не выбор, а ограничение. На практике большинство бизнесов продаёт одновременно минимум на двух маркетплейсах, на своём сайте и в офлайн-точке.",
        },
        {
            type: "p",
            text:
                "Вторая причина — структура комиссий. С 1 мая 2026 года комиссия Uzum Market привязана к категории товара и составляет от 3% до 35%. С той же даты введён логистический сбор — от 2 000 до 20 000 сум. Теперь то, какую категорию продавать в каком канале, стало отдельным решением.",
        },
        {
            type: "p",
            text:
                "Третья причина — маркировка. С 1 июля 2026 года при продаже маркированного товара код маркировки обязательно отражается в чеке онлайн-ККМ. Значит, остатки нужно вести не на уровне «есть 10 штук», а на уровне конкретных кодов. Вести такой учёт в Excel по трём каналам невозможно.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Где ломается ручное ведение?" },
        {
            type: "p",
            text:
                "Ручное ведение работает в одном канале, буксует в двух и ломается в трёх. Точка поломки всегда одна и та же — разрыв во времени.",
        },
        {
            type: "p",
            text:
                "Менеджер вносит остатки утром. В течение дня на маркетплейсе продаётся пять штук, на сайте две, в магазине три. Вечером цифры обновляются. Все восемь часов между этими двумя моментами система продолжает продавать товар, которого уже нет.",
        },
        {
            type: "list",
            items: [
                "Оверселл: товара нет, а заказ принят. Его приходится отменять.",
                "Рейтинг на маркетплейсе падает, показы карточки сокращаются, и это бьёт по обороту.",
                "Теряется доверие покупателя — после отмены он обычно не возвращается.",
                "Расхождение цен: акцию поменяли в одном канале, в другом осталась старая цена.",
                "Время менеджера: в нашей практике ручной ввод остатков занимает один-два часа в день.",
            ],
        },
        {
            type: "p",
            text:
                "Важный нюанс: проблема обостряется не при росте ассортимента, а при добавлении канала. Второй канал увеличивает число ошибок не вдвое, а заметно сильнее, потому что растёт количество пар, которые нужно сверять.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Сколько стоит оверселл?" },
        {
            type: "p",
            text:
                "Эту статью можно посчитать точно. Формула простая: число отменённых заказов × средний чек × маржа. Сверху добавляются косвенные потери.",
        },
        {
            type: "p",
            text:
                "Пример: 600 заказов в месяц, средний чек 250 000 сум, маржа 25%. Если 3% заказов отменяются из-за расхождения остатков — это 18 заказов, 4,5 млн сум оборота и 1,1 млн сум чистой прибыли. Каждый месяц.",
        },
        {
            type: "p",
            text:
                "Сверху идёт время менеджера: час в день — это 22 часа в месяц. И самое дорогое — рейтинг. Когда показатель отмен на маркетплейсе растёт, карточка опускается в выдаче, а на её возврат уходит несколько месяцев.",
        },
        {
            type: "callout",
            text:
                "Подставьте свои цифры: число заказов в месяц × процент отмен × средний чек × маржа. Полученная сумма — бюджет, который вы можете ежемесячно направлять на интеграцию.",
        },

        { type: "h2", text: "Что именно синхронизируется?" },
        {
            type: "p",
            text:
                "Под словом «синхронизация» обычно понимают только остатки. На деле потоков четыре, и каждый движется в своём направлении.",
        },
        {
            type: "table",
            head: ["Данные", "Направление", "Требуемая скорость", "Что будет без синхронизации"],
            rows: [
                ["Остатки", "Со склада в каналы", "Почти в реальном времени", "Оверселл и отмены заказов"],
                ["Цены и акции", "Со склада в каналы", "Несколько раз в день", "Разные цены в каналах, споры"],
                ["Заказы", "Из каналов на склад", "Немедленно", "Заказ пропускается"],
                ["Статус заказа", "Со склада в каналы", "При смене этапа", "Клиент звонит, оператор не в курсе"],
                ["Карточка товара", "Со склада в каналы", "При изменении", "Старое описание и фото, рост возвратов"],
            ],
        },
        {
            type: "p",
            text:
                "Практический совет: не делайте всё сразу. На первом этапе подключите только остатки и заказы — это закрывает бо́льшую часть потерь. Цены и карточки добавляются вторым этапом, когда первый уже работает стабильно.",
        },

        { type: "h2", text: "Как устроена интеграция?" },
        {
            type: "p",
            text:
                "Архитектурный принцип один: единый источник истины. Вы один раз решаете, где хранятся остатки, и все остальные системы берут данные оттуда.",
        },
        {
            type: "ol",
            items: [
                "В центре стоит учётная система — 1С, ERP или складской модуль. Остатки меняются только в ней.",
                "Для каждого канала пишется коннектор: API маркетплейса, сайт, касса или POS-система.",
                "При изменении остатка центр отправляет обновление в каналы; канал сообщает центру о новом заказе.",
                "Логика резервирования: проданный товар сразу блокируется, при отмене заказа возвращается в доступные.",
                "Правило разрешения конфликтов: если товар продан в двух каналах одновременно, какой из них приоритетнее — решите заранее.",
                "Журнал и оповещения: если синхронизация остановилась, узнать об этом нужно сразу, а не на следующий день.",
            ],
        },
        {
            type: "p",
            text:
                "Чаще всего упускают пятый пункт. Без правила разрешения конфликтов система работает технически верно, но выдаёт результаты, которые невозможно объяснить менеджеру.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Когда интеграция окупается?" },
        {
            type: "p",
            text:
                "Здесь решают два числа: количество SKU и количество каналов. С их ростом стоимость ручного ведения увеличивается не линейно, а быстрее.",
        },
        {
            type: "table",
            head: ["Ситуация", "Рекомендация", "Почему"],
            rows: [
                ["1 канал, до 50 SKU", "Ведите вручную", "Ошибок мало, автоматизация не окупится"],
                ["2 канала, до 200 SKU", "Полуавтомат: общая таблица и ежедневная выгрузка", "Ошибки есть, но пока управляемы"],
                ["2–3 канала, больше 200 SKU", "Полная интеграция", "Стоимость ошибок превышает бюджет интеграции"],
                ["3 канала и больше", "Полная интеграция без исключений", "Ручной контроль практически невозможен"],
                ["Маркируемые товары", "Полная интеграция", "Коды невозможно вести вручную"],
            ],
        },
        {
            type: "p",
            text:
                "Граница получается примерно такой: два канала и больше двухсот SKU. После этой точки ежемесячный убыток от ручного ведения превышает амортизацию интеграции.",
        },

        { type: "h2", text: "Сколько стоит и за сколько окупается?" },
        {
            type: "p",
            text:
                "В Innobek ERP и учётные системы начинаются от 40 000 000 сум, сложные конфигурации — от 75 000 000 сум. Если учётная система у вас уже есть, написание коннектора — заметно меньший объём работ, зависящий от числа каналов и возможностей API.",
        },
        {
            type: "p",
            text:
                "В цену не входят: тарифы на стороне маркетплейса, складское оборудование и сканеры штрихкодов, первичная чистка данных. Последний пункт обычно занимает больше всего времени: названия, единицы измерения и артикулы в каналах записаны по-разному.",
        },
        {
            type: "p",
            text:
                "Окупаемость считается по формуле выше. Потеря 1,1 млн сум прибыли в месяц — это 13,2 млн сум в год, и сверх того 22 часа времени менеджера ежемесячно. Коннектор к существующей системе обычно окупается в течение года, ERP с нуля — за 18–24 месяца.",
        },
        {
            type: "p",
            text:
                "Важная оговорка: расчёт работает, только если число каналов и SKU превышает границу из таблицы выше. Ниже неё интеграция технически правильна, но экономически преждевременна.",
        },

        { type: "h2", text: "Из чего складывается цена бездействия?" },
        {
            type: "p",
            text:
                "Стоимость ручного ведения остатков не видна в отчёте отдельной строкой — она размазана по другим цифрам.",
        },
        {
            type: "list",
            items: [
                "Упущенная маржа на отменённых заказах — самая крупная и самая незаметная статья.",
                "Падение рейтинга на маркетплейсе и сокращение показов после него.",
                "Время менеджера: один-два часа в день, несколько сотен часов в год.",
                "Избыточный запас: чтобы не ошибаться, склад намеренно переполняют, и деньги замораживаются в товаре.",
                "Качество решений: невозможно точно понять, какой канал выгоднее в какой категории.",
            ],
        },

        { type: "h2", text: "Когда интеграция не нужна?" },
        {
            type: "p",
            text:
                "Интеграция — не универсальное решение. В перечисленных ниже случаях мы советуем направить бюджет на другое.",
        },
        {
            type: "list",
            items: [
                "Один канал и до пятидесяти SKU. Здесь достаточно Excel и дисциплины.",
                "Товар производится под заказ — понятия складского остатка практически нет.",
                "Ассортимент меняется постоянно и не повторяется, например, в ручном производстве.",
                "Учётной системы ещё нет и в ближайший месяц не появится. Сначала наладьте учёт, потом подключайте.",
                "Один из каналов открыт как эксперимент и может закрыться через три месяца.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "p",
            text:
                "Во всех остальных случаях порядок такой: сначала наведите порядок в остатках внутри учётной системы, затем подключите самый крупный канал, потом остальные. Попытка подключить всё одновременно растягивает проект и отодвигает результат.",
        },
    ],

    faq: [
        {
            q: "С какого количества каналов нужна синхронизация?",
            a: "Практическая граница — два канала и больше двухсот SKU. При одном канале и пятидесяти позициях достаточно Excel и дисциплины. При трёх и более каналах ручной контроль становится практически невозможным. Если вы работаете с маркируемыми товарами, интеграция нужна даже при небольшом числе каналов.",
        },
        {
            q: "Сколько убытка приносит оверселл?",
            a: "Формула такая: число заказов в месяц × процент отмен × средний чек × маржа. Например, при 600 заказах, 3% отмен, чеке 250 000 сум и марже 25% это около 1,1 млн сум чистой прибыли в месяц. Сверху добавляется падение рейтинга на маркетплейсе — на его восстановление уходит несколько месяцев.",
        },
        {
            q: "Что именно синхронизируется между каналами?",
            a: "Четыре основных потока: остатки (со склада в каналы, почти в реальном времени), цены и акции, заказы (из каналов на склад, немедленно) и статусы заказов. Пятый — карточка товара. На первом этапе подключайте только остатки и заказы: это закрывает большую часть потерь и запускается быстрее.",
        },
        {
            q: "Сколько стоит интеграция?",
            a: "В Innobek ERP и учётные системы — от 40 000 000 сум, сложные конфигурации — от 75 000 000 сум. Если учётная система уже есть, написание коннектора обойдётся заметно дешевле. В цену не входят тарифы маркетплейса, складское оборудование и первичная чистка данных — последняя обычно занимает больше всего времени.",
        },
        {
            q: "Как маркировка влияет на учёт остатков?",
            a: "С 1 июля 2026 года при продаже маркированного товара код маркировки обязательно отражается в чеке онлайн-ККМ. Это требует вести остатки не на уровне «столько-то штук», а на уровне конкретных кодов. В нескольких каналах такой учёт вручную не ведётся, поэтому интеграция становится обязательной.",
        },
        {
            q: "Если уйти с маркетплейса, проблема решится?",
            a: "Нет, обычно это худшее решение. Маркетплейс даёт готовый трафик и доверие, а построить их с нуля значительно дороже. Правильный путь — сохранить каналы и вести остатки из одного источника. Вывод категорий с высокой комиссией на свой сайт — отдельное решение, и после синхронизации оно даётся проще.",
        },
    ],

    cta: {
        h: "Свяжем ваши каналы с одним складом",
        p: "Расскажите, сколько у вас каналов и SKU — бесплатно оценим объём интеграции, сроки и подготовим расчёт окупаемости.",
        button: "Запросить расчёт",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-omnichannel.webp",
            alt: "Поток данных от одного склада к трём каналам продаж",
            caption: "Один склад, три канала — остаток должен меняться только в одном месте",
            prompt:
                "Hub-and-spoke illustration: a central warehouse icon connected by animated-looking data lines to three channel icons — marketplace storefront, own website and a physical shop counter; isometric-lite flat vector, blue and teal, clean white background, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-integration-arch.webp",
            alt: "Архитектура обмена остатками, ценами, заказами и статусами",
            caption: "Единый источник истины: учётная система в центре, коннекторы по краям",
            prompt:
                "Integration architecture diagram: ERP/stock core in the middle, API connectors on the left to marketplace and on the right to web store and POS, with arrows labelled stock, price, order, status; clean technical line style, blue highlights, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-stock-mismatch.webp",
            alt: "Ручные расхождения в остатках и единый синхронизированный остаток",
            caption: "Слева — три цифры в трёх каналах, справа — один реальный остаток",
            prompt:
                "Before-and-after comparison: left a spreadsheet with mismatched stock numbers highlighted in red across three columns; right a single dashboard row showing one synced stock figure with green status across three channel badges; minimal light UI, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/bobo-market-app.webp",
            alt: "Приложение Bobo Market — каталог и управление заказами",
            caption: "Bobo Market — каталог и управление заказами для многоканальных продаж",
        },
    ],

    relatedServices: ["erp-tizimlar", "internet-dokonlar", "veb-ilovalar"],
    relatedPosts: ["marketpleys-yoki-oz-internet-dokon", "onlayn-tolov-ulash-payme-click", "internetdokon"],
};

const content = { uz, ru };

export default content;
